import { AnyType } from 'src/globalTypes';

export const isObject = (value: AnyType): value is Object =>
  typeof value === 'object' && value !== null;
